export default {
  drawer: null,
  color: "success",
  // image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
  image:
    "https://firebasestorage.googleapis.com/v0/b/enercred.appspot.com/o/web%2Fmenu%2Fenercred-03.jpg?alt=media&token=7867c6c1-3d1b-45ce-a812-b3c074b42a01",
};
